// src/bus.js
import Vue from "vue";
// 创建一个空的 Vue 实例作为事件总线
const Bus = new Vue();
// 导出这个实例，供所有组件使用
export default Bus;
